import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { cn } from "./cn";
/** Centered content column with the standard page gutter. */
export function Container({ children, className, width = "content", }) {
    return (_jsx("div", { className: cn("mx-auto w-full px-6 md:px-8", width === "prose" ? "max-w-prose" : "max-w-content", className), children: children }));
}
/** A vertical section with consistent rhythm and optional tinted ground. */
export function Section({ children, className, tint, id, }) {
    return (_jsx("section", { id: id, className: cn("py-section", tint === "sunk" && "bg-paper-sunk dark:bg-ink-soft", tint === "ink" && "bg-ink text-paper dark:bg-black", className), children: children }));
}
/** Section eyebrow + heading + optional lead, the standard section head. */
export function SectionHead({ eyebrow, title, lead, align = "left", className, }) {
    return (_jsxs("div", { className: cn("max-w-prose", align === "center" && "mx-auto text-center", className), children: [eyebrow && _jsx("p", { className: "ds-eyebrow mb-4", children: eyebrow }), _jsx("h2", { className: "text-display-md text-balance", children: title }), lead && (_jsx("p", { className: "text-lead text-mute dark:text-mute-soft mt-5", children: lead }))] }));
}
